"use client";

import { DropdownMenu, type DropdownMenuItemProps } from "@pharaday/lighthouse";
import type { Url } from "next/dist/shared/lib/router/router";
import type { HTMLAttributeAnchorTarget, MouseEventHandler, ReactNode, SVGProps } from "react";

export interface UserMenuItemProps {
  separator?: boolean;
  className?: string;
  color?: DropdownMenuItemProps["color"];
  label?: string;
  Icon?: (props: SVGProps<SVGSVGElement>) => ReactNode;
  handler?: MouseEventHandler;
  url?: Url;
  target?: HTMLAttributeAnchorTarget;
}

const UserMenuItem = ({ Icon, className, color, handler, label, separator, target, url }: UserMenuItemProps) => {
  return (
    <>
      {label && (
        <DropdownMenu.Item
          leading={Icon && { icon: Icon }}
          color={color}
          className={className}
          onClick={handler}
          link={url ? { href: url, target } : undefined}
          label={label}
        />
      )}

      {separator && <DropdownMenu.Separator />}
    </>
  );
};

export default UserMenuItem;
